import { render, staticRenderFns } from "./LastActivityModal.vue?vue&type=template&id=70717c7d"
import script from "./LastActivityModal.vue?vue&type=script&lang=js"
export * from "./LastActivityModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports